import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticsService } from '@core/services/analytics.service';
import { SearchService } from '@core/services/search.service';
import { select, Store } from '@ngrx/store';
import { TurnLandingViewOff } from '@store/context/context.actions';
import { selectContextCore, selectContextLanding } from '@store/context/context.selector';
import { IContextCore } from '@store/context/context.state';
import { IHotelsAppState } from '@store/index';
import { selectInitialSearchData } from '@store/search/search.selector';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'am-search-widget',
  styleUrls: ['./search-widget.component.scss'],
  templateUrl: './search-widget.component.html',
})
export class SearchWidgetComponent implements OnInit {
  @Input()
  public entity: any;
  @Input()
  public busy: boolean;
  @Input()
  public section: string;
  @Output()
  public resetState: EventEmitter<any> = new EventEmitter<any>();
  @Input()
  public isDisney: boolean;
  @Input()
  public total: number;
  @Input()
  public showStatus = false;

  public locale: string;
  public country: string;
  public brand: string;
  public channel: string;
  public textFind: string;
  public textAvailables: string;
  public textAvailable: string;
  public dates: any;
  public distribution: any;
  public hostnameArray: any;
  public isWeb: boolean;
  public countryMap: any;
  public resultTotals: string;
  public statusItems: { icon: string; text: string }[];
  public initialData$: Observable<any>;
  public context$: Observable<IContextCore>;
  public isLanding$: Observable<boolean>;

  constructor(
    private analyticsService: AnalyticsService,
    private store$: Store<IHotelsAppState>,
    private searchService: SearchService,
    private router: Router,
  ) {}

  public ngOnInit() {
    this.context$ = this.store$.pipe(select(selectContextCore));
    this.initialize();
  }

  public initialize() {
    this.showSearchBox();
    this.setIsLanding();
  }

  public showSearchBox() {
    this.initialData$ = this.store$.pipe(
      select(selectInitialSearchData),
      filter((data) => data !== undefined),
      map((data) => this.searchService.prepareSearchInfo(data)),
    );

    this.initialData$.subscribe((response) => {
      console.log(response);
    });
  }

  public handleSearch(data) {
    if (this.searchService.searchValidator(data)) {
      this.searchService
        .prepareNavigationData(data)
        .subscribe((uri) => {
          if (uri) {
            this.router.navigate([uri.path], {
              queryParams: uri.params,
            });
            this.store$.dispatch(new TurnLandingViewOff());
          }
        })
        .unsubscribe();
    }
    this.trackReSearchSubmit();
  }

  public trackReSearchSubmit() {
    this.analyticsService.trackEvent({
      action: 'Submit Research Form',
      label: 'Submit Form',
      section: this.section === 'detail' ? 'Detail' : 'Results',
    });
  }

  private setIsLanding() {
    this.isLanding$ = this.store$.pipe(select(selectContextLanding));
  }
}
